import { useIntl } from "react-intl";
const useTranslation = () => {
  const intl = useIntl();
  const t = (id, values = {}) => intl.formatMessage({ id }, values);

  return { t };
};
export default useTranslation;
